import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();
  return (
    <LegalLayout title={t('legalPages.privacy.title')} lastUpdated={t('legalPages.lastUpdatedDate')}>
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.privacy.intro.title')}</h2>
          <p className="text-gray-700 mb-4">
            {t('legalPages.privacy.intro.p1')}
          </p>
          <p className="text-gray-700">
            {t('legalPages.privacy.intro.p2')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.privacy.dataCollected.title')}</h2>
          <h3 className="text-xl font-semibold text-gray-800 mb-3">{t('legalPages.privacy.dataCollected.byYou.title')}</h3>
          <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
            <li>{t('legalPages.privacy.dataCollected.byYou.items.0')}</li>
            <li>{t('legalPages.privacy.dataCollected.byYou.items.1')}</li>
            <li>{t('legalPages.privacy.dataCollected.byYou.items.2')}</li>
            <li>{t('legalPages.privacy.dataCollected.byYou.items.3')}</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-800 mb-3">{t('legalPages.privacy.dataCollected.auto.title')}</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>{t('legalPages.privacy.dataCollected.auto.items.0')}</li>
            <li>{t('legalPages.privacy.dataCollected.auto.items.1')}</li>
            <li>{t('legalPages.privacy.dataCollected.auto.items.2')}</li>
            <li>{t('legalPages.privacy.dataCollected.auto.items.3')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.privacy.usage.title')}</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>{t('legalPages.privacy.usage.items.0')}</li>
            <li>{t('legalPages.privacy.usage.items.1')}</li>
            <li>{t('legalPages.privacy.usage.items.2')}</li>
            <li>{t('legalPages.privacy.usage.items.3')}</li>
            <li>{t('legalPages.privacy.usage.items.4')}</li>
            <li>{t('legalPages.privacy.usage.items.5')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.privacy.sharing.title')}</h2>
          <p className="text-gray-700 mb-4">
            {t('legalPages.privacy.sharing.p')}
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>{t('legalPages.privacy.sharing.items.0')}</li>
            <li>{t('legalPages.privacy.sharing.items.1')}</li>
            <li>{t('legalPages.privacy.sharing.items.2')}</li>
            <li>{t('legalPages.privacy.sharing.items.3')}</li>
            <li>{t('legalPages.privacy.sharing.items.4')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.privacy.security.title')}</h2>
          <p className="text-gray-700 mb-4">
            {t('legalPages.privacy.security.p')}
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>{t('legalPages.privacy.security.items.0')}</li>
            <li>{t('legalPages.privacy.security.items.1')}</li>
            <li>{t('legalPages.privacy.security.items.2')}</li>
            <li>{t('legalPages.privacy.security.items.3')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.privacy.rights.title')}</h2>
          <p className="text-gray-700 mb-4">
            {t('legalPages.privacy.rights.p')}
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>{t('legalPages.privacy.rights.items.0')}</li>
            <li>{t('legalPages.privacy.rights.items.1')}</li>
            <li>{t('legalPages.privacy.rights.items.2')}</li>
            <li>{t('legalPages.privacy.rights.items.3')}</li>
            <li>{t('legalPages.privacy.rights.items.4')}</li>
            <li>{t('legalPages.privacy.rights.items.5')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.privacy.retention.title')}</h2>
          <p className="text-gray-700">
            {t('legalPages.privacy.retention.p')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.contact.title')}</h2>
          <p className="text-gray-700 mb-4">
            {t('legalPages.contact.p')}
          </p>
          <div className="bg-gray-100 p-4 rounded-lg">
            <p className="text-gray-700"><strong>{t('legalPages.contact.email')}</strong> privacy@tapeat.com</p>
            <p className="text-gray-700"><strong>{t('legalPages.contact.phone')}</strong> +351 968 682 315</p>
            <p className="text-gray-700"><strong>{t('legalPages.contact.address')}</strong> Açores, Portugal</p>
          </div>
        </section>
      </div>
    </LegalLayout>
  );
};

export default PrivacyPolicy;